import { createAppAsyncThunk, getReceiptItemAvailableQuantity } from '@/warehouse/helpers';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { useItemWorkflowTableStore } from '@/warehouse/components/ItemWorkflowTable/business';
import { workflowItemProcessedSnackbarDuration } from '@/warehouse/constants';
import { playWarehouseSound } from '@/warehouse/hooks';
import { stockReceiptActions } from '../stockReceipt.state';
/** Plays 'full' sound in case there are no available items or opens `PlaceReceiptItemDialog` otherwise. */
const tryPlaceStockReceiptItem = createAppAsyncThunk('stockReceipt/tryPlaceStockReceiptItem', async ({ receiptItem, stockId }, { dispatch }) => {
    if (!receiptItem) {
        const { searchTerm, setSearchTerm } = useItemWorkflowTableStore.getState();
        if (searchTerm.trim().length === 0)
            return;
        // A single snackbar is allowed at one moment. Manually closing the existed one.
        closeSnackbar();
        playWarehouseSound('error');
        enqueueSnackbar({
            key: searchTerm,
            preventDuplicate: true,
            variant: 'receiptSubmissionError',
            article: searchTerm,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            autoHideDuration: workflowItemProcessedSnackbarDuration,
        });
        setSearchTerm('');
        return;
    }
    const availableQuantity = getReceiptItemAvailableQuantity(receiptItem);
    if (availableQuantity < 1) {
        playWarehouseSound('full');
        return;
    }
    const dialogData = { receiptItem, stockId };
    dispatch(stockReceiptActions.openPlaceReceiptItemDialog(dialogData));
});
export { tryPlaceStockReceiptItem };
